import VideoModal from './TestModal'

export default VideoModal
